module.exports = __webpack_public_path__ + "static/media/A10.28987551.png";